/***
*
*   ROW
*   Renders a new landing page row
*
*   PROPS
*   align: left/right/center
*   color: dark/tint/brand
*
**********/

import React, { useContext } from 'react';
import { ClassHelper, ViewContext } from 'components/lib';
import { readableTextColor } from 'components/survey/formTheme';
import { RowHeader } from './header.js';
import { Content } from './content.js'
import Style from './row.tailwind.js';
import { Image } from '../../image/image'
export function Row(props){

  const css = ClassHelper(Style, {

    [props.color]: props.color, 
    center: props.align === 'center',
    left: props.align === 'left',

  });

  // A brand row follows the route's theme when a public view published one. The
  // bg-brand-500 class stays as the base, and the fallback here is that same
  // colour, so authenticated views are byte-identical to before.
  const context = useContext(ViewContext);
  const brandBackground = context?.brandColor?.to || '#8C66F2';
  const brandStyle = props.color === 'brand'
    ? {
        backgroundColor: brandBackground,
        // the base class pairs bg-brand-500 with text-white; a light customer
        // primary would leave headings unreadable, so the text follows the colour
        color: readableTextColor(brandBackground) || undefined,
      }
    : undefined;

  if (props.header){
    return (
      <header className={ css } style={ brandStyle }>
        <Content>

          { props.children }
  
        </Content>
        
      </header>
    );
  }

  return (
    <section className={ css } style={ brandStyle }>
      <Content>
      
        <RowHeader
          title={ props.title }
          desc={ props.desc }
          color={ props.color }
          mainTitle={ props.mainTitle }
        />
        { props.children }

      </Content>
    </section>
  )
}